import FALRoot from './FALRoot'
import FADRoot from './FADRoot'
import FASRoot from './FASRoot'
import FADHomeRoot from './FADHomeRoot'

window.FALRoot = FALRoot
window.FADRoot = FADRoot
window.FASRoot = FASRoot
window.FADHomeRoot = FADHomeRoot
